import { APP_CONFIG } from '../../config';

type DataLayerEvent = {
    event: string;
    [key: string]: string | number | boolean | null | undefined;
};

const getDataLayer = () => {
    window.dataLayer = window.dataLayer || [];
    return window.dataLayer;
};

export const initializeGoogleTagManager = () => {
    const containerId = APP_CONFIG.GTM.container_id;

    if (!containerId) return;

    getDataLayer().push({
        'gtm.start': new Date().getTime(),
        event: 'gtm.js',
    });

    const firstScript = document.getElementsByTagName('script')[0];
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${encodeURIComponent(containerId)}`;
    firstScript.parentNode?.insertBefore(script, firstScript);
};

export const pushDataLayerEvent = (event: DataLayerEvent) => {
    getDataLayer().push(event);
};
